/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'selected': _vm.selected},attrs:{"id":"TagContainer"},on:{"click":function($event){return _vm.selectionFunction(_vm.tagId)}}},[_c('h6',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }